export default __webpack_public_path__ + "static/media/virusred-250-3-min.13d50263.png";